(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 767px)');
  const GAP = 16;
  const BAR_SELECTORS = [
    '.halo-sticky-toolbar-mobile',
    '.starumi-product-purchase-actions',
    '[data-sticky-add-to-cart]'
  ];
  let frame;
  let resizeObserver;

  const isVisibleBottomBar = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity || 1) > 0 &&
      rect.height > 0 &&
      rect.bottom >= window.innerHeight - 2 &&
      rect.top < window.innerHeight
    );
  };

  const safeAreaInset = () => {
    const probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;visibility:hidden;height:env(safe-area-inset-bottom);';
    document.body.appendChild(probe);
    const inset = probe.getBoundingClientRect().height;
    probe.remove();
    return inset;
  };

  const updatePosition = () => {
    frame = 0;
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;

    if (!MOBILE_QUERY.matches) {
      chat.style.removeProperty('--shopify-agent-activator-offset');
      chat.style.removeProperty('z-index');
      return;
    }

    const bars = BAR_SELECTORS
      .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
      .filter(isVisibleBottomBar);

    const topEdge = bars.reduce(
      (top, element) => Math.min(top, element.getBoundingClientRect().top),
      window.innerHeight
    );
    const coveredHeight = Math.max(0, window.innerHeight - topEdge);
    const bottomClearance = coveredHeight > 0 ? coveredHeight : safeAreaInset();

    chat.style.setProperty(
      '--shopify-agent-activator-offset',
      `${Math.ceil(bottomClearance + GAP)}px`,
      'important'
    );
    chat.style.setProperty('z-index', '79', 'important');
  };

  const scheduleUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(updatePosition);
  };

  const observeBars = () => {
    resizeObserver?.disconnect();
    resizeObserver = new ResizeObserver(scheduleUpdate);
    BAR_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => resizeObserver.observe(element));
    });
  };

  const refresh = () => {
    observeBars();
    scheduleUpdate();
  };

  new MutationObserver(refresh).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  new MutationObserver(scheduleUpdate).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  MOBILE_QUERY.addEventListener?.('change', scheduleUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
